import { Navigate, Outlet } from 'react-router-dom';
import SideBar from '../componants/sidebar/SideBar';
import { useStateContext } from '../Contexts/ContextProvider';
import Navbar from '../componants/navbar/Navbar';
import Notification from '../assets/Notification';
import { Fade } from 'react-awesome-reveal';
import Footer from '../componants/Footer';

function AdminLayout() {
  const { token, notifications } = useStateContext();

  if (!token) {
    return <Navigate to="/" />;
  }

  return (
    <div className="app-shell">
      <SideBar />

      <main className="app-main">
        <Navbar />

        <div className="app-page">
          <Outlet />
        </div>

        <Footer />

        <div className="notification-stack">
          {notifications.map((notifi) => (
            <div key={notifi.id}>
              <Fade triggerOnce>
                <Notification notification={notifi} />
              </Fade>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default AdminLayout;
